import { RefundMeGcoinRefundablelistRaw, RefundMeGcoinRefundlistItemRaw, RefundMeGcoinRefundlistRaw } from "@features/product/model/refundMeModel";

/**
 * Refund 대상 목록
 * [GET] /refund/me/gcoin/refundablelist
 */
export const refundMeGcoinRefundablelistData: RefundMeGcoinRefundablelistRaw = {
  refundableInfos: [
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "4000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "3000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "2000",
      refundableCoinStatus: 2,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5531,
      registerDate: "2018-08-17T15:29:59.168+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "1000",
      refundableCoinStatus: 1,
      paymentType: 6,
      refundCommission: 1000,
      estimatedRefundAmount: 1000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "4000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "3000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "2000",
      refundableCoinStatus: 2,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5531,
      registerDate: "2018-08-17T15:29:59.168+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "1000",
      refundableCoinStatus: 1,
      paymentType: 6,
      refundCommission: 1000,
      estimatedRefundAmount: 1000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "4000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "3000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "2000",
      refundableCoinStatus: 2,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5531,
      registerDate: "2018-08-17T15:29:59.168+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "1000",
      refundableCoinStatus: 1,
      paymentType: 6,
      refundCommission: 1000,
      estimatedRefundAmount: 1000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "4000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "3000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "2000",
      refundableCoinStatus: 2,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5531,
      registerDate: "2018-08-17T15:29:59.168+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "1000",
      refundableCoinStatus: 1,
      paymentType: 6,
      refundCommission: 1000,
      estimatedRefundAmount: 1000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "4000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "3000",
      refundableCoinStatus: 3,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5537,
      registerDate: "2018-08-21T09:59:40.888+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "2000",
      refundableCoinStatus: 2,
      paymentType: 2,
      refundCommission: 1000,
      estimatedRefundAmount: 5000,
    },
    {
      purchaseId: 5531,
      registerDate: "2018-08-17T15:29:59.168+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "1000",
      refundableCoinStatus: 1,
      paymentType: 6,
      refundCommission: 1000,
      estimatedRefundAmount: 1000,
    },
    {
      purchaseId: 5531,
      registerDate: "2018-08-17T15:29:59.168+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "1000",
      refundableCoinStatus: 1,
      paymentType: 6,
      refundCommission: 1000,
      estimatedRefundAmount: 1000,
    },
    {
      purchaseId: 5531,
      registerDate: "2018-08-17T15:29:59.168+09:00",
      goodsId: 100173,
      goodsName: "[블소] 찬란한 화수분(30개입)",
      chargeAmount: "1000",
      refundableCoinStatus: 1,
      paymentType: 6,
      refundCommission: 1000,
      estimatedRefundAmount: 1000,
    },
  ],
};

/**
 * Refund 목록 (환불 신청한 목록인거 같음)
 * [GET] /refund/me/gcoin/refundlist
 */
export const refundMeGcoinRefundlistDataList: RefundMeGcoinRefundlistItemRaw[] = [
  { refundReceptionId: 1002, userId: "user123", refundStatus: 1, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명2" },
  { refundReceptionId: 1001, userId: "user123", refundStatus: 2, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명1" },
  { refundReceptionId: 1003, userId: "user123", refundStatus: 3, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명3" },
  { refundReceptionId: 1004, userId: "user123", refundStatus: 5, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명4" },
  { refundReceptionId: 1005, userId: "user123", refundStatus: 6, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명5" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 7, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명6" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 8, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명6" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 9, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명7" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 10, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명8" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 253, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명9" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 254, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명10" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 254, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명11" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 255, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명12" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 999, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명13" },
  { refundReceptionId: 1001, userId: "user123", refundStatus: 2, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명14" },
  { refundReceptionId: 1002, userId: "user123", refundStatus: 1, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명15" },
  { refundReceptionId: 1003, userId: "user123", refundStatus: 3, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명16" },
  { refundReceptionId: 1004, userId: "user123", refundStatus: 5, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명17" },
  { refundReceptionId: 1005, userId: "user123", refundStatus: 6, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명18" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 9, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명19" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 9, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명20" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 10, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명21" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 253, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명22" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 254, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명23" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 255, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명24" },
  { refundReceptionId: 1006, userId: "user123", refundStatus: 999, refundStatusDescription: "환불 처리 완료", registered: "2022-11-01 14:55:28.690 +09:00", succeededRefundAmount: "70000", refundCommission: "500", succeededRefundKey: "RFND-20250516-0001", goodsName: "상품명25" },
];

// export const refundMeGcoinRefundlistData: RefundMeGcoinRefundlistRaw = {
//   totalCount: 1,
//   refunds: refundMeGcoinRefundlistDataList,
// };



/**
 * Refund 취소(삭제)
 * [DELETE] /refund/me/refundid/{refundReceptionId}/delete
 */
export const refundMeRefundIdDeleteData = null;

/**
 * Refund gcoin 환불 - 카드 결제 취소
 * [POST] /refund/me/paymentid/{paymentId}/cardcancel
 */
export const refundMePaymentIdCardcancelData = null;

/**
 * Refund gcoin 환불 - 송금 이체
 * [POST} /refund/me/regist
 */
export const refundMeRegistData = null;
